// Asset constants for BrandLabAI brand
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_c890f6c6-4905-4b62-a50a-01a64352f884/artifacts/138ynry4_IMG_7490.jpeg";

export const BRAND = {
  name: "BrandLabAI",
  legalName: "AI Brandcraft LLC",
  email: "hello@brandlab-ai.com",
  phone: "+1 954 554 6781",
  phoneHref: "+19545546781",
  domain: "www.brandlab-ai.com",
  // WhatsApp number (digits only, country code first). Update here if a
  // different WhatsApp-enabled number should receive all "let's talk" CTAs.
  whatsappNumber: "19545546781",
};

/**
 * Build a wa.me deep link for the main "let's talk" CTAs.
 * Accepts an optional pre-filled message (string or i18n value).
 */
export function whatsappLink(message = "") {
  const base = `https://wa.me/${BRAND.whatsappNumber}`;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
}
